import { render, staticRenderFns } from "./ApplicationCases.vue?vue&type=template&id=c537dc84&scoped=true"
import script from "./ApplicationCases.vue?vue&type=script&lang=js"
export * from "./ApplicationCases.vue?vue&type=script&lang=js"
import style0 from "./ApplicationCases.vue?vue&type=style&index=0&id=c537dc84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c537dc84",
  null
  
)

export default component.exports